import styled from 'styled-components';

export const StatsPanelContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
  min-height: 120px;
  flex-direction: column;
`;
